import React, { useEffect, useState } from "react";

import { connect } from "react-redux";

import Select from "./index";

function Currency({ config, dispatch, name = "currency", rows, ...props }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (config.length && rows && rows.length) {
      let items = config
        .map((entity) => entity.currency)
        .concat(rows.map((row) => row[name]));
      items = items.filter((item, index) => items.indexOf(item) === index);
      items.sort();
      setItems(items);
    }
  }, [config, name, rows]);

  return (
    <Select label="Currency" items={items} name={name} rows={rows} {...props} />
  );
}

const mapStateToProps = (state) => ({
  config: state.prp.config.length ? state.prp.config : state.prp.me.config,
});

export default connect(mapStateToProps)(Currency);
